var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Timepicker',{attrs:{"input-class":"time-input","manual-input":"","input-width":"80px","format":_vm.timeFormat,"minute-interval":_vm.minuteInterval},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }